export default {
    state: {
        user: {},
        student: {},
    },
    mutations: {
        SET_PUBLIC_USER(state, payload) {
            state.user.public = payload;
        },
        SET_USER_PHOTO(state, payload) {
            state.user.photo = payload;
        },
        SET_USER_ID(state, payload) {
            state.user.id = payload;
        },
        SET_USER_NAME(state, payload) {
            state.user.name = payload;
        },
        SET_STUDENT(state, payload) {
            state.student = payload;
        },
    },
    getters: {
        USER(state) {
            return state.user;
        },
        STUDENT(state) {
            return state.student;
        },
    },
};
